import { deferredToPromise, runRemoteCommand } from "../../Util.ts";
import { createExecCommandCallback, encodeFileHash } from "../../elfinder/ElFinder.ts";

async function createNewFormTheme(fm: elFinder.ElFinderInstance): Promise<void> {
  const response = await runRemoteCommand(BackendCommand?.ClientFormTheme?.createNewFormTheme, []);
  const volumeId = response.volumeId;
  await deferredToPromise(fm.sync());
  if (volumeId !== undefined) {
    const hash = encodeFileHash(volumeId, "");
    await deferredToPromise(fm.exec("open", hash));
    await deferredToPromise(fm.exec("info", hash));
  }
}

/**
 * Creates a command for the ElFinder file manager that allows the user to create a new form theme.
 * @returns The new ElFinder command.
 */
export function createCreateNewThemeCommand(): elFinder.ElFinderCommandHandlerBaseStatic<elFinder.BaseElFinderCommandOptions> {
  const command: elFinder.ElFinderCommandHandlerBaseStatic<elFinder.BaseElFinderCommandOptions> = function () {
    this.exec = createExecCommandCallback(createNewFormTheme);

    this.getstate = () => 1;

    this.init = function (this: elFinder.ElFinderCommandHandlerBase<elFinder.BaseElFinderCommandOptions>) {
      this.className = "create-new-theme";
      this.title = this.fm.i18n("createNewTheme");
      this.name = "createNewTheme";
    };
  };

  return command;
}
